export const socketPath = "http://node.qhide.com:4000";
